/* eslint-disable */
import axios from 'axios';
import root from '../_helpers/roots';
let GlobalAllUserSendMailUrl = root.globalAllUserSendMailUrl.link;
let SelectedAllUserSendMailUrl = root.selectedAllUserSendMailUrl.link;
let UnSignedUpAllUserSendMailUrl = root.unSignedUpAllUserSendMailUrl.link;
let userReqForDemoApiUrl = root.userReqForDemoApiUrl.link;
export default {
  state: {
  },
  mutations: {
  },
  actions: {
    userReqForDemoAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(userReqForDemoApiUrl, payload).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    sentAllUserEmailFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(GlobalAllUserSendMailUrl, payload).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    sentMultipleUserEmailFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(SelectedAllUserSendMailUrl, payload).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    sentUnsubscribedMultipleUserEmailFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(UnSignedUpAllUserSendMailUrl, payload).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
  },
  getters: {
  }
}